import { trackEvent } from "utils/analytics";

// Unified Signup Clicked
// Moreden Signup Clicked
// Unified Signup Agree Clicked
// Signup Next Step Clicked
// Signup Submitted
// License Registration Clicked
// Home Return Clicked

export const trackUnifiedSignupClicked = (property: object) => {
  trackEvent("Unified Signup Clicked", property);
};

export const trackMoredenSignupClicked = (property: object) => {
  trackEvent("Moreden Signup Clicked", property);
};

export const trackUnifiedSignupAgreeClicked = (property: object) => {
  trackEvent("Unified Signup Agree Clicked", property);
};

export const trackSignupNextStepClicked = (property: object) => {
  trackEvent("Signup Next Step Clicked", property);
};

export const trackSignupSubmitted = (property: object) => {
  trackEvent("Signup Submitted", property);
};

export const trackLicenseRegistrationClicked = (property: object) => {
  trackEvent("License Registration Clicked", property);
};

export const trackHomeReturnClicked = (property: object) => {
  trackEvent("Home Return Clicked", property);
};

export const trackJobSelectionButtonClicked = (property: object) => {
  trackEvent("Job Selection Button Clicked", property);
};
